import React from 'react'
import { Link } from "react-router-dom";

const OnGridOffGridSolar = () => {
  return (
    <>


      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">On-Grid & Off-Grid Solar</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>On-Grid & Off-Grid Solar</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/On-Grid.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">On-Grid & Off-Grid Solar Solutions – Yogesh Solar Energy</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      At Yogesh Solar Energy, we provide advanced and reliable solar power solutions tailored to meet residential, commercial, and industrial energy needs. Whether you want to reduce your electricity bills or achieve complete energy independence, our On-Grid and Off-Grid Solar Systems are designed for maximum efficiency and long-term savings.
                    </p>
                    <h3 className="mb-20">On-Grid Solar System (Grid-Tied)</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      An On-Grid Solar System is connected to the local electricity grid, allowing you to generate your own power while staying linked to the utility supply.
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                        <h3 className="mb-3">Key Benefits:</h3>
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" />Significant reduction in electricity bills, 
                          Net metering facility for exporting excess power, 
                          Low maintenance and cost-effective, 
                          Seamless integration with existing power supply</li>
                        <li><i className="far fa-check-double" />  Expert consultation & customized system design</li>
                        <li><i className="far fa-check-double" />  High-quality solar panels and components</li>
                        <li><i className="far fa-check-double" />  Professional installation and maintenance</li>
                        <li><i className="far fa-check-double" />  Government subsidy assistance</li>
                        <li><i className="far fa-check-double" /> Affordable pricing with long-term ROI </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default OnGridOffGridSolar